import { createContext, useContext } from "react";
import useNavigation from "shared/hooks/use-navigation";

const NavigationContext = createContext(null);

export const NavigationProvider = ({ children }) => {

    const navigation = useNavigation();

    return (
        <NavigationContext.Provider value={navigation}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigationContext = () => {
    const ctx = useContext(NavigationContext);
    if (!ctx) {
        throw new Error("useNavigation must be used inside a NavigationProvider");
    }
    return ctx;
};
